// also remember to register new modals in modalsComponents.tsx
export enum Modals {
    ModalConfirm = "ModalConfirm",
    ModalConfirmWithHeader = "ModalConfirmWithHeader",
    ModalSlideUp = "ModalSlideUp",
    ModalWith2Buttons = "ModalWith2Buttons",
}
